/**
 * <AdminMfaEnroll> — fluxo de enrollment TOTP.
 * Onda 1B do hardening (junho/2026).
 */

import React, { useEffect, useState } from 'react';
import { enrollTotp, finishTotpEnrollment } from './adminAuth';

export default function AdminMfaEnroll({ user, onDone, onCancel }) {
  const [secret, setSecret] = useState(null);
  const [qrUrl, setQrUrl] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const out = await enrollTotp(user);
        if (!mounted) return;
        setSecret(out.secret);
        setQrUrl(out.qrCodeUrl);
        setSecretKey(out.secretKey);
      } catch (e) {
        setError(e?.message || 'Falha ao iniciar enrollment.');
      }
    })();
    return () => {
      mounted = false;
    };
  }, [user]);

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (!code || code.length < 6) {
      setError('Digite o código de 6 dígitos.');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      await finishTotpEnrollment(user, secret, code, 'Authenticator app');
      onDone?.();
    } catch (e) {
      setError(e?.message || 'Código inválido. Tente novamente.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={fullScreen}>
      <form style={card} onSubmit={handleSubmit}>
        <h2 style={{ marginTop: 0 }}>Configurar 2FA (obrigatório)</h2>
        <p style={{ color: '#6b7280', marginTop: 0, fontSize: 14 }}>
          A partir desta atualização, o painel administrativo exige autenticação
          em dois fatores. Use Google Authenticator, 1Password, Authy ou similar.
        </p>

        {qrUrl ? (
          <>
            <p style={{ fontSize: 13, margin: '14px 0 6px' }}>
              1. Escaneie o QR code no app autenticador.
            </p>
            <div style={{ background: '#fff', padding: 10, borderRadius: 8, border: '1px solid #e5e7eb', textAlign: 'center' }}>
              {/* O QR vem como otpauth:// URL — usamos via api.qrserver para nao adicionar dependencia.
                  Em produção, recomenda-se gerar localmente com `qrcode.react`. */}
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(qrUrl)}`}
                alt="QR Code"
                style={{ width: 220, height: 220 }}
              />
            </div>
            <details style={{ marginTop: 10, fontSize: 12, color: '#6b7280' }}>
              <summary style={{ cursor: 'pointer' }}>Chave manual</summary>
              <p style={{ wordBreak: 'break-all', fontFamily: 'monospace' }}>{secretKey}</p>
            </details>
            <p style={{ fontSize: 13, margin: '14px 0 6px' }}>
              2. Digite o código de 6 dígitos gerado pelo app.
            </p>
            <input
              type="text"
              inputMode="numeric"
              pattern="\d{6}"
              maxLength={6}
              autoComplete="one-time-code"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              style={input}
              disabled={submitting}
              required
            />
          </>
        ) : (
          <p style={{ color: '#6b7280' }}>Gerando QR…</p>
        )}

        {error && <p style={errorBox}>{error}</p>}

        <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
          <button type="submit" disabled={submitting || !qrUrl} style={btnPrimary}>
            {submitting ? 'Confirmando…' : 'Confirmar e ativar 2FA'}
          </button>
          <button type="button" onClick={onCancel} style={btnSecondary} disabled={submitting}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
}

const fullScreen = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f4f4f5',
  padding: 16,
  fontFamily: "'Segoe UI', Roboto, sans-serif",
};

const card = {
  background: '#fff',
  borderRadius: 12,
  padding: '28px',
  maxWidth: 480,
  width: '100%',
  boxShadow: '0 6px 24px rgba(0,0,0,0.08)',
};

const input = {
  marginTop: 4,
  padding: '12px 14px',
  borderRadius: 8,
  border: '1px solid #d1d5db',
  fontSize: 22,
  outline: 'none',
  width: '100%',
  textAlign: 'center',
  letterSpacing: 4,
};

const errorBox = {
  background: '#fef2f2',
  color: '#b91c1c',
  border: '1px solid #fecaca',
  padding: '8px 12px',
  borderRadius: 8,
  marginTop: 14,
  fontSize: 13,
};

const btnPrimary = {
  flex: 1,
  padding: '12px 18px',
  background: '#00A4E0',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  fontSize: 15,
  cursor: 'pointer',
  fontWeight: 600,
};

const btnSecondary = {
  padding: '12px 18px',
  background: '#fff',
  color: '#374151',
  border: '1px solid #d1d5db',
  borderRadius: 8,
  fontSize: 15,
  cursor: 'pointer',
};
